const KNOWN_MESSAGES = {
  "device invalid": "设备无效或已停用",
  "device offline": "设备离线，指令没有下发",
  "device overdue": "设备已过期，不能下发指令",
  "command send failed": "指令下发失败",
  "command send success": "指令已下发",
  "device not found": "未找到这台设备",
  "missing ed_id": "缺少设备编号",
  "invalid hd_no": "货道号无效",
  "read only": "当前操作只允许查询",
  "too many requests": "操作过于频繁，请稍后再试",
  "phone required": "请填写手机号",
  "bad_amount": "金额不正确",
  "deposit_not_enough": "押金不足",
  "useralreadyexists": "用户已存在",
  "invalid_role": "角色无效",
  "no_permission": "没有权限执行该操作",
  "permission denied": "没有权限执行该操作",
  "cannot_delete_root": "不能删除主账号",
  "not_store_user": "不是本店用户",
  "invalid logo": "Logo 无效",
  "invalid currey": "币种无效",
  "invalid date range": "日期范围无效",
  "invalid statistics type": "统计类型无效",
  "cardexit_active": "卡号已存在，且当前是启用状态",
  "usernameexit": "用户名已存在",
  "save failed": "保存失败",
  "save_sync_config_failed": "保存同步配置失败",
  "bind_session_failed": "绑定会话失败",
  "havenopayorder": "没有待支付订单",
  "can not add more": "不能再添加货道",
  "sql error": "数据写入失败",
  "激活失败": "激活失败",
  "保存失败": "保存失败",
  "打印内容为空": "打印内容为空",
  "未找到打印机配置": "未找到打印机配置",
  "打印机未启用": "打印机未启用",
  "打印机未配置授权码或设备id": "打印机未配置授权码或设备 ID",
  "测试打印失败": "测试打印失败",
  "指令重复下发": "这条打酒指令已经下发过，请不要重复下发",
  "非三货道扫码设备": "这台设备不是三货道扫码设备",
  "非葡萄牙4路设备": "这台设备不是葡萄牙 4 路设备",
};

const GENERIC_TOASTS = new Set([
  "操作失败",
  "修改失败",
  "错误",
  "加载数据失败",
  "failed",
  "error",
  "operation failed",
  "change fail",
  "failed to load data",
]);

let pendingDetail = "";
let pendingAt = 0;

function textOf(value) {
  if (typeof value === "string") {
    return value.trim();
  }
  if (value && typeof value === "object") {
    if (typeof value.msg === "string" && value.msg.trim()) {
      return value.msg.trim();
    }
    if (typeof value.message === "string" && value.message.trim()) {
      return value.message.trim();
    }
  }
  return "";
}

function looksLikeSql(text) {
  return /^(select|update|insert|delete|replace)\b/i.test(text);
}

export function translateApiText(text) {
  const raw = textOf(text);
  if (!raw || looksLikeSql(raw)) {
    return "";
  }
  return KNOWN_MESSAGES[raw.toLowerCase()] || raw;
}

export function isGenericApiToast(text) {
  const raw = textOf(text).toLowerCase();
  return GENERIC_TOASTS.has(raw);
}

export function formatApiError(data) {
  if (!data || typeof data !== "object") {
    return "";
  }
  const status = Number(data.status);
  const translated = translateApiText(data.msg) || translateApiText(data.message) || translateApiText(data.error);
  if (translated && !isGenericApiToast(translated)) {
    return translated;
  }
  if (status) {
    return "操作失败（状态 " + status + "）";
  }
  return translated;
}

export function rememberApiFailure(data) {
  if (!data || typeof data !== "object") {
    return;
  }
  const status = Number(data.status);
  if (!status || status === 200 || status === 403) {
    return;
  }
  const detail = formatApiError(data);
  if (!detail) {
    return;
  }
  pendingDetail = detail;
  pendingAt = Date.now();
}

function currentDetail() {
  if (!pendingDetail || Date.now() - pendingAt > 1500) {
    pendingDetail = "";
    return "";
  }
  const detail = pendingDetail;
  pendingDetail = "";
  return detail;
}

export function presentApiToast(text) {
  const raw = textOf(text);
  if (!raw) {
    return text;
  }
  if (isGenericApiToast(raw)) {
    return currentDetail() || raw;
  }
  return translateApiText(raw) || raw;
}

export function installApiErrorToast(Vue, Message) {
  function showMessage(options) {
    if (typeof options === "string") {
      return Message(presentApiToast(options));
    }
    if (
      options &&
      typeof options === "object" &&
      typeof options.message === "string" &&
      (options.type === "error" || options.type === "warning")
    ) {
      return Message(
        Object.assign({}, options, {
          message: presentApiToast(options.message),
        })
      );
    }
    return Message(options);
  }

  ["success", "warning", "info", "error"].forEach(function (type) {
    showMessage[type] = function (options) {
      if (typeof options === "string") {
        options = { message: options };
      }
      options = Object.assign({}, options, { type: type });
      return showMessage(options);
    };
  });
  showMessage.close = Message.close;
  showMessage.closeAll = Message.closeAll;
  Vue.prototype.$message = showMessage;
  return showMessage;
}
